module.exports = __webpack_public_path__ + "img/cancelled_delivery.5d99f1fa.svg";